export default __webpack_public_path__ + "static/media/insta5.9eb1b406.jpg";